module.exports = __webpack_public_path__ + "static/media/Akkurat-Light.58bf9936.woff2";